import { normalizeSettings } from '../game/model.mjs';
export const API_BASE_URL = (import.meta.env?.VITE_BACKEND_URL || 'https://quantumbattleship.onrender.com/api/v1').replace(/\/$/, '');
async function request(path, options = {}) {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), options.timeoutMs || 120000);
  try {
    const response = await fetch(`${API_BASE_URL}${path}`, { ...options, headers: { 'Content-Type': 'application/json', ...options.headers }, signal: controller.signal });
    const payload = await response.json().catch(() => null);
    if (!response.ok) {
      const detail = payload?.detail;
      const error = new Error(typeof detail === 'string' ? detail : `The server could not complete this request (${response.status}).`);
      error.status = response.status;
      throw error;
    }
    if (!payload || typeof payload !== 'object') throw new Error('The server returned an unreadable response.');
    return payload;
  } catch (error) {
    if (error.name === 'AbortError') throw new Error('The request timed out. Check the match before trying again.');
    if (error instanceof TypeError) throw new Error('Cannot reach the game server. Check your connection and try again.');
    throw error;
  } finally { window.clearTimeout(timeout); }
}
export const getConfig = () => request('/config', { timeoutMs: 10000 });
export const getGameState = id => request(`/games/${encodeURIComponent(id)}`);
export async function createBackendGame(settings) {
  const { level, executionMode, aiStrategy } = normalizeSettings(settings);
  const created = await request('/games', { method: 'POST', body: JSON.stringify({ level, difficulty: 'medium', execution_mode: executionMode, ai_strategy: aiStrategy }) });
  if ((created.ai_strategy && created.ai_strategy !== aiStrategy) || (!created.ai_strategy && aiStrategy !== 'checkerboard')) {
    throw new Error('The game server could not start the selected AI strategy. Please try again later or choose checkerboard.');
  }
  return created;
}
export const placeFleet = (id, ships) => request(`/games/${encodeURIComponent(id)}/fleet`, { method: 'POST', body: JSON.stringify({ ships }) });
export const executePlayerTurn = (id, { coordinate, attackType, expectedTurn }) => request(`/games/${encodeURIComponent(id)}/turns/player`, { method: 'POST', body: JSON.stringify({ coordinate, attack_type: attackType, expected_turn: expectedTurn }) });
export const usePlayerEntanglement = id => request(`/games/${encodeURIComponent(id)}/entangle/player`, { method: 'POST', body: '{}' });
